<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      title="打印"
      id-key="UserId"
      :fullscreen="true"
    >
      <div class="print">
        <div class="print_view">
          <div class="print_view_div m-scroll " >
            <div id="page" ref="page">
              <div
                v-for="(pageItem, pageIndex) in pages"
                :key="pageIndex"
                style="page-break-after: always; position: relative;"
                :class="{ page_border: form.border }"
                :style="{
                  width: width + 'px',
                  height: height + 'px',
                  padding: margin + 'px',
                }"
              >
                <div
                  style="position: relative;
                        top: 0;
                        left: 0;
                        bottom: 0;
                        right: 0;"
                  :style="{ height: tableForm.topHeight + 'px', border: topBorder ? '1px solid #ccc' : 'none' }"
                >
                  <div
                    v-for="(item, index) in divs"
                    :key="index"
                    :style="{
                      display: item.style.display,
                      position: item.style.position,
                      width: item.style.width + item.widthUnit,
                      height: item.style.height + item.heightUnit,
                      top: item.style.top + item.topUnit,
                      left: item.style.left + item.leftUnit,
                      justifyContent: item.style.justifyContent,
                      alignItems: item.style.alignItems,
                      fontSize: item.style.fontSize + 'px',
                      fontWeight: item.style.fontWeight,
                      fontStyle: item.style.fontStyle,
                      fontFamily: item.style.fontFamily,
                      border: item.style.isBorder ? '1px solid #ccc' : 'none',
                    }"
                  >
                    {{ item.text }}
                  </div>
                </div>
                <div 
                  style="display: flex"
                  :style="{
                      width:
                        tableForm.title.style.width + tableForm.title.widthUnit,
                      height: tableForm.title.style.height + 'px',
                      justifyContent: tableForm.title.style.justifyContent,
                      alignItems: tableForm.title.style.alignItems,
                      paddingLeft:
                        tableForm.title.style.paddingLeft +
                        tableForm.title.style.paddingLeftUnit,
                      paddingRight:
                        tableForm.title.style.paddingRight +
                        tableForm.title.style.paddingRightUnit,
                      fontSize: tableForm.title.style.fontSize + 'px',
                      fontWeight: tableForm.title.style.fontWeight,
                      fontStyle: tableForm.title.style.fontStyle,
                      fontFamily: tableForm.title.style.fontFamily,
                      border: titleBorder ? '1px solid #ccc' : 'none' 
                    }"
                >
                  {{
                      tableForm.title.name
                    }}
                </div>

                <div 
                  style="position: relative; display: flex; flex-wrap: wrap;"
                  :style="{
                    width: formContainer.width + formContainer.widthUnit,
                    height: formContainer.height + formContainer.heightUnit,
                    border: formContainer.isBorder ? '1px solid #ccc' : 'none',
                    marginLeft: formContainer.marginLeft + formContainer.marginLeftUnit,
                  }"
                >

                  <div style="display: flex; flex-shrink: 0;" v-for="item in formList" :key="item.key"
                    :style="{
                      width: item.style.width + item.style.widthUnit,
                      height: item.style.height + item.style.heightUnit,
                      marginLeft: item.style.marginLeft + item.style.marginLeftUnit,
                      marginRight: item.style.marginRight + item.style.marginRightUnit,
                      marginTop: item.style.marginTop + item.style.marginTopUnit,
                      marginBottom: item.style.marginBottom + item.style.marginBottomUnit,
                    }"
                  >
                    <div style="display: flex;" :style="{
                      height: item.labelStyle.height + item.labelStyle.heightUnit,
                      width: item.labelStyle.width + item.labelStyle.widthUnit,
                      justifyContent: item.labelStyle.justifyContent,
                      alignItems: item.labelStyle.alignItems,
                      fontSize:  item.labelStyle.fontSize + 'px',
                      fontWeight:  item.labelStyle.fontWeight,
                      fontStyle: item.labelStyle.fontStyle,
                      fontFamily: item.labelStyle.fontFamily,
                      border:  item.labelStyle.isBorder ? '1px solid #ccc' : 'none',
                    }">{{item.label}}</div>
                    <div style="display: flex;" :style="{
                      height: item.valueStyle.height + item.valueStyle.heightUnit,
                      width: item.valueStyle.width + item.valueStyle.widthUnit,
                      justifyContent: item.valueStyle.justifyContent,
                      alignItems: item.valueStyle.alignItems,
                      fontSize:  item.valueStyle.fontSize + 'px',
                      fontWeight:  item.valueStyle.fontWeight,
                      fontStyle: item.valueStyle.fontStyle,
                      fontFamily: item.valueStyle.fontFamily,
                        border:  item.valueStyle.isBorder ? '1px solid #ccc' : 'none',
                    }">{{item.value}}</div>
                  </div>
                </div>
                <table
                  style="position: relative; border-collapse: collapse;"
                  border
                  :style="{
                    width: tableForm.width + tableForm.widthUnit,
                    left: tableForm.position.left + tableForm.position.leftUnit,
                    top: tableForm.position.top + tableForm.position.topUnit,
                  }"
                >
                 <tr v-for="(aitem, i) in newThead" :key="'a' + i">
                    <th
                      v-for="(bitem) in aitem"
                      :key="bitem.data.key"
                      :rowspan="bitem.rowspan"
                      :colspan="bitem.colspan"
                      @click="theadClick(bitem)"
                      :style="{
                        width: bitem.data.style.width + 'px',
                        textAlign: bitem.data.style.textAlign,
                        verticalAlign: bitem.data.style.verticalAlign,
                        height: tableForm.thead.theadHeight + 'px',
                        fontSize: bitem.data.style.fontSize + 'px',
                        fontWeight: bitem.data.style.fontWeight,
                        fontStyle: bitem.data.style.fontStyle,
                        fontFamily: bitem.data.style.fontFamily,
                      }"
                    >{{bitem.data.label}}</th>
                  </tr>
                  <tbody>
                    <tr
                      v-for="(item, index) in tempTbodyData"
                      :key="'tr' + index"
                      :style="{
                        height: trHeight[index] + 'px',
                        display: tableCountMode ? 'none' : 'table-row',
                      }"
                      @click="trClick(index, item, $event)"
                    >
                      <td
                        v-for="(item1, index) in item"
                        :data-index="index"
                        :key="item1.key"
                        :style="{
                          textAlign: item1.data.style.textAlign,
                          verticalAlign: item1.data.style.verticalAlign,
                          fontSize: item1.data.style.fontSize + 'px',
                          fontWeight: item1.data.style.fontWeight,
                          fontStyle: item1.data.style.fontStyle,
                          fontFamily: item1.data.style.fontFamily,
                        }"
                      >
                        {{ item1.data.value }}
                      </td>
                    </tr>
                    <tr
                      v-for="(item, index) in tableCountData[pageItem]"
                      :key="index"
                      :style="{
                        height: trHeight[index] + 'px',
                        display: tableCountMode ? 'table-row' : 'none',
                      }"
                      @click="trClick(index, item, $event)"
                    >
                      <td
                        v-for="(item1, index) in item"
                        :data-index="index"
                        :key="item1.key"
                        :style="{
                          textAlign: item1.data.style.textAlign,
                          verticalAlign: item1.data.style.verticalAlign,
                          fontSize: item1.data.style.fontSize + 'px',
                          fontWeight: item1.data.style.fontWeight,
                          fontStyle: item1.data.style.fontStyle,
                          fontFamily: item1.data.style.fontFamily,
                        }"
                      >
                        {{ item1.data.value }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr v-show="showSumTr && !tableCountMode" :style="{height: sumTrHight + 'px'}">
                      <td v-for="(item) in sumTrs" :key="item.key" @click="sumTdClick(item)"
                      :style="{
                          textAlign: item.style.textAlign,
                          verticalAlign: item.style.verticalAlign,
                          fontSize: item.style.fontSize + 'px',
                          fontWeight: item.style.fontWeight,
                          fontStyle: item.style.fontStyle,
                          fontFamily: item.style.fontFamily,
                        }"
                      >{{item.value}}</td>
                    </tr>
                    <tr v-show="showSumTr && tableCountMode" :style="{height: sumTrHight + 'px'}">
                      <td v-for="(item) in countSumTrs[pageItem]" :key="item.key" @click="sumTdClick(item)"
                      :style="{
                          textAlign: item.style.textAlign,
                          verticalAlign: item.style.verticalAlign,
                          fontSize: item.style.fontSize + 'px',
                          fontWeight: item.style.fontWeight,
                          fontStyle: item.style.fontStyle,
                          fontFamily: item.style.fontFamily,
                        }"
                      >{{item.value}}</td>
                    </tr>
                  </tfoot>
                  
                </table>

                <div
                  style="position: relative;
                        top: 0;
                        left: 0;
                        bottom: 0;
                        right: 0;"
                  :style="{ height: tableForm.bottomHeight + 'px',  border: bottomBorder ? '1px solid #ccc' : 'none'  }"
                >

                  <div
                    v-for="(item, index) in bottomDivs"
                    :key="index"
                    :ref="item.key"
                    :style="{
                      display: item.style.display,
                      position: item.style.position,
                      width: item.style.width + item.widthUnit,
                      height: item.style.height + item.heightUnit,
                      top: item.style.top + item.topUnit,
                      left: item.style.left + item.leftUnit,
                      justifyContent: item.style.justifyContent,
                      alignItems: item.style.alignItems,
                      fontSize: item.style.fontSize + 'px',
                      fontWeight: item.style.fontWeight,
                      fontStyle: item.style.fontStyle,
                      fontFamily: item.style.fontFamily,
                      border: item.style.isBorder ? '1px solid #ccc' : 'none',
                    }"
                  >
                    {{ item.text }}
                  </div>
                </div>
                <div style="height: 150px; position: relative;" :style="{height: tableForm.imgAreaHeight + 'px'}">
                  <div style="position: relative;display: flex;justify-content: center;align-items: center;overflow: hidden;" v-for="(item) in imgList" :key="item.key"  :style="{
                    width: item.style.width + item.style.widthUnit,
                    height: item.style.height + item.style.heightUnit,
                    left: item.style.left + item.style.leftUnit,
                    top: item.style.top + item.style.topUnit,
                    borderRadius: item.style.borderRadius ? '50%' : '0px'
                  }" @click="imgClick(item)">
                      <img style="width: 100%;" class="img" :src="item.src" >
                  </div>
                </div>
                <el-divider  content-position="center" v-if="form.isPageSize">第{{pageIndex+1}}页/总{{pages.length}}页</el-divider>
              </div>
            </div>
          </div>
        </div>
        <div class="print_tool">
          <el-tabs type="card" @tab-click="tabClick">
            <el-tab-pane label="表单项" style="height: 300px;">
              <div class="columns_name m-scroll" style="height: 100%;">
                <el-tree
                  class="tree"
                  show-checkbox
                  :data="formDataList"
                  :props="formDefaultProps"
                  @node-click="formHandleNodeClick"
                  @check-change="formFandleCheckChange"
                ></el-tree>
              </div>
            </el-tab-pane>
            <el-tab-pane label="表单设置">
              <div class="columns_name m-scroll">
                 <el-form :data="formContainer">
                  <el-form-item label="宽度" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="formContainer.width"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="formContainer.widthUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                    
                  </el-form-item>
                   <el-form-item label="高度" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="formContainer.height"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="formContainer.heightUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                   <el-form-item label="左边距" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="formContainer.marginLeft"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="formContainer.marginLeftUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                   <el-form-item label="边框" class="mtx8 mrx8">
                      <el-checkbox v-model="formContainer.isBorder"></el-checkbox>
                  </el-form-item>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="列名">
              <div class="columns_name m-scroll">
                <el-tree
                  class="tree"
                  show-checkbox
                  :data="columnsData"
                  :props="defaultProps"
                  @check="handleCheckChange"
                ></el-tree>
              </div>
            </el-tab-pane>
            <el-tab-pane label="表格设置">
              <div class="columns_name m-scroll">
                <el-form :model="tableForm" label-width="100px">
                  <el-form-item label="表格宽度" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="tableForm.width"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="tableForm.widthUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="表头高度" class="mtx8 mrx8">
                    <el-input
                      type="number"
                      v-snum
                      v-model="tableForm.thead.theadHeight"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="表格上方高度" class="mtx8 mrx8">
                    <el-input
                      type="number"
                      v-snum
                      v-model="tableForm.topHeight"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="表格下方高度" class="mtx8 mrx8">
                    <el-input
                      type="number"
                      v-snum
                      v-model="tableForm.bottomHeight"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="表格上方边框" class="mtx8 mrx8">
                      <el-checkbox v-model="topBorder"></el-checkbox>
                  </el-form-item>
                   <el-form-item label="表格下方边框" class="mtx8 mrx8">
                      <el-checkbox v-model="bottomBorder"></el-checkbox>
                  </el-form-item>
                  <el-form-item label="表格标题边框" class="mtx8 mrx8">
                      <el-checkbox v-model="titleBorder"></el-checkbox>
                  </el-form-item>
                  <el-form-item label="图片区域高度" class="mtx8 mrx8">
                    <el-input
                      type="number"
                      v-snum
                      v-model="tableForm.imgAreaHeight"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="左距离" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="tableForm.position.left"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="tableForm.position.leftUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="上距离" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="tableForm.position.top"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="tableForm.position.topUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                   <el-form-item label="显示合计" class="mtx8 mrx8">
                      <el-checkbox v-model="showSumTr" @change="showSumFunc"></el-checkbox>
                  </el-form-item>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="标题设置">
              <div class="columns_name m-scroll">
                <el-form :model="tableForm" label-width="80px">
                  <el-form-item label="标题" class="mtx8 mrx8">
                    <el-input v-model="tableForm.title.name"></el-input>
                  </el-form-item>
                  <el-form-item label="高度" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="tableForm.title.style.height"
                      ></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item label="宽度" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="tableForm.title.style.width"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="tableForm.title.widthUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="水平对齐" class="mtx8 mrx8">
                    <el-radio-group v-model="tableForm.title.style.justifyContent">
                      <el-radio label="flex-start">左对齐</el-radio>
                      <el-radio label="center">居中</el-radio>
                      <el-radio label="flex-end">右对齐</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="垂直对齐" class="mtx8 mrx8">
                    <el-radio-group v-model="tableForm.title.style.alignItems">
                      <el-radio label="flex-start">上对齐</el-radio>
                      <el-radio label="center">居中</el-radio>
                      <el-radio label="flex-end">下对齐</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="左边距" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="tableForm.title.style.paddingLeft"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="tableForm.title.style.paddingLeftUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="右边距" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="tableForm.title.style.paddingRight"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="tableForm.title.style.paddingRightUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="字体大小" class="mtx8 mrx8">
                    <el-select v-model="tableForm.title.style.fontSize">
                      <el-option
                        v-for="item in fonts"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="字体粗细" class="mtx8 mrx8">
                    <el-input
                      type="number"
                      v-snum
                      v-model="tableForm.title.style.fontWeight"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="斜体" class="mtx8 mrx8">
                    <el-radio-group v-model="tableForm.title.style.fontStyle">
                      <el-radio label="normal">普通</el-radio>
                      <el-radio label="italic">斜体</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="字体风格" class="mtx8 mrx8">
                    <el-select v-model="tableForm.title.style.fontFamily">
                      <el-option
                        v-for="item in fontFamily"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="页面设置">
              <div class="columns_name m-scroll">
                <el-form :model="form" label-width="100px">
                  <el-form-item label="纸张大小" class="mtx8">
                    <el-select v-model="form.size" @change="changeSize">
                      <el-option
                        v-for="item in paperType"
                        :key="item.key"
                        :label="item.label"
                        :value="{ value: item.value, label: item.label }"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="自定义大小" class="mtx8" v-if="formInputShow">
                    <div class="flex">
                      <el-input
                        type="text"
                        v-model="form.formInputValue"
                        placeholder="格式：宽*高,如210*297"
                      ></el-input>
                      <el-button type="primary" @click="changeInputValue"
                        >确定</el-button
                      >
                    </div>
                  </el-form-item>
                  <el-form-item label="纸张方向" class="mtx8">
                    <el-radio-group
                      v-model="form.direction"
                      @change="changeDirection"
                    >
                      <el-radio label="portrait">纵向</el-radio>
                      <el-radio label="landscape">横向</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="表格最大条数" class="mtx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-model="form.tableCount"
                      ></el-input>
                      <el-button type="primary" @click="tableCountFunc"
                        >确定</el-button
                      >
                    </div>
                  </el-form-item>
                  <el-form-item label="边框" class="mtx8">
                    <el-checkbox v-model="form.border"></el-checkbox>
                  </el-form-item>
                  <el-form-item label="显示页码" class="mtx8">
                    <el-checkbox v-model="form.isPageSize"></el-checkbox>
                  </el-form-item>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="文本框">
             
            <el-tabs type="card">
                <el-tab-pane label="上方" style="height: 300px;">
                   <div class="flex justify mtx8 mrx8">
                  <el-button type="primary" @click="createDIV"
                    >创建</el-button
                  >
                  <el-button
                    type="danger"
                    :disabled="waitDelDivIndex === -1 || divs.length === 0"
                    @click="delDiv"
                    >删除</el-button
                  >
                </div>
                <div class="columns_name m-scroll" style="height: 270px;">
                  <el-tree
                    class="tree"
                    :data="divs"
                    :props="divsProp"
                    @node-click="handleNodeClickDiv"
                  ></el-tree>
                </div>
                </el-tab-pane>
                <el-tab-pane label="下方">
                  <div class="flex justify mtx8 mrx8">
                    <el-button type="primary" @click="b_createDIV"
                      >创建</el-button
                    >
                    <el-button
                      type="danger"
                      :disabled="
                        b_waitDelDivIndex === -1 || bottomDivs.length === 0
                      "
                      @click="b_delDiv"
                      >删除</el-button
                    >
                  </div>
                  <div class="columns_name m-scroll" style="height: 270px;">
                    <el-tree
                      class="tree"
                      :data="bottomDivs"
                      :props="divsProp"
                      @node-click="b_handleNodeClickDiv"
                    ></el-tree>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="图片">
              <div class="flex justify mtx8 mrx8">
                  <upload-file :showTip="false" accept=".jpeg,.png" @input="addImg" :data="{dic:'images'}" />
                  
              </div>
                <div class="columns_name m-scroll" >
                  <el-form :model="imgForm" label-width="80px" v-if="imgFormShow">
                    <el-form-item label="图片编号" class="mtx8 mrx8">
                      <span>{{imgForm.key}}</span>
                    </el-form-item>
                     <el-form-item label="宽度" class="mtx8 mrx8">
                      <div class="flex">
                        <el-input
                          type="number"
                          style="flex: 1"
                          v-model="imgForm.style.width"
                        ></el-input>
                        <el-select style="width: 60px;" v-model="imgForm.style.widthUnit">
                          <el-option label="px" value="px"></el-option>
                          <el-option label="%" value="%"></el-option>
                        </el-select>
                      </div>
                    </el-form-item>
                    <el-form-item label="高度" class="mtx8 mrx8">
                      <div class="flex">
                        <el-input
                          type="number"
                          style="flex: 1"
                          v-model="imgForm.style.height"
                        ></el-input>
                        <el-select style="width: 60px;" v-model="imgForm.style.heightUnit">
                          <el-option label="px" value="px"></el-option>
                          <el-option label="%" value="%"></el-option>
                        </el-select>
                      </div>
                    </el-form-item>
                    <el-form-item label="左距离" class="mtx8 mrx8">
                      <div class="flex">
                        <el-input
                          type="number"
                          style="flex: 1"
                          v-model="imgForm.style.left"
                        ></el-input>
                        <el-select style="width: 60px;" v-model="imgForm.style.leftUnit">
                          <el-option label="px" value="px"></el-option>
                          <el-option label="%" value="%"></el-option>
                        </el-select>
                      </div>
                    </el-form-item>
                     <el-form-item label="上距离" class="mtx8 mrx8">
                      <div class="flex">
                        <el-input
                          type="number"
                          style="flex: 1"
                          v-model="imgForm.style.top"
                        ></el-input>
                        <el-select style="width: 60px;" v-model="imgForm.style.topUnit">
                          <el-option label="px" value="px"></el-option>
                          <el-option label="%" value="%"></el-option>
                        </el-select>
                      </div>
                    </el-form-item>
                    <el-form-item label="圆形" class="mtx8 mrx8">
                      <el-checkbox v-model="imgForm.style.borderRadius"></el-checkbox>
                    </el-form-item>
                    <el-form-item label="操作" class="mtx8 mrx8">
                      <el-button type="danger" @click="delImg">删除</el-button>
                    </el-form-item>
                  </el-form>
                </div>
            </el-tab-pane>
          </el-tabs>
          <!-- 属性设置 -->
          <div class="attr_card" v-show="attrShow && isTheadShow ">
            <div class="h3_title">内容设置</div>
            <el-tabs type="card" style="height: 80%">
              <el-tab-pane label="表头" class="attrs m-scroll">
                <div>
                  <el-form :model="attrForm" label-width="80px ">
                    <el-form-item label="列名" class="mtx8 mrx8">
                      <el-input v-model="attrForm.columnName"></el-input>
                    </el-form-item>
                     <el-form-item label="参与合计" class="mtx8 mrx8" v-if="showSumTr">
                      <el-checkbox v-model="attrForm.isSum" @change="changeIsSum"></el-checkbox>
                    </el-form-item>
                    <el-form-item label="宽度" class="mtx8 mrx8">
                      <el-input
                        type="number"
                        v-model="attrForm.width"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="序号" class="mtx8 mrx8">
                      <el-input
                        type="number"
                        v-model="attrForm.sn"
                        @change="changeSn"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="水平对齐" class="mtx8 mrx8">
                      <el-radio-group v-model="attrForm.textAlign">
                        <el-radio label="left">左对齐</el-radio>
                        <el-radio label="center">居中</el-radio>
                        <el-radio label="right">右对齐</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="垂直对齐" class="mtx8 mrx8">
                      <el-radio-group v-model="attrForm.verticalAlign">
                        <el-radio label="baseline">上对齐</el-radio>
                        <el-radio label="middle">居中</el-radio>
                        <el-radio label="bottom">下对齐</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="字体大小" class="mtx8 mrx8">
                      <el-select v-model="attrForm.fontSize">
                        <el-option
                          v-for="item in fonts"
                          :key="item"
                          :label="item"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="字体粗细" class="mtx8 mrx8">
                      <el-input
                        type="number"
                        v-snum
                        v-model="attrForm.fontWeight"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="斜体" class="mtx8 mrx8">
                      <el-radio-group v-model="attrForm.fontStyle">
                        <el-radio label="normal">普通</el-radio>
                        <el-radio label="italic">斜体</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="字体风格" class="mtx8 mrx8">
                      <el-select v-model="attrForm.fontFamily">
                        <el-option
                          v-for="item in fontFamily"
                          :key="item"
                          :label="item"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
              </el-tab-pane>
              <el-tab-pane label="表体">
                <el-form
                  :model="tdData"
                  label-width="80px "
                  v-if="tdData.trHeight"
                >
                  <el-form-item label="行高" class="mtx8 mrx8">
                    <el-input
                      type="number"
                      v-snum
                      v-model="tdData.trHeight"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="水平对齐" class="mtx8 mrx8">
                    <el-radio-group v-model="tdData.td.data.style.textAlign">
                      <el-radio label="left">左对齐</el-radio>
                      <el-radio label="center">居中</el-radio>
                      <el-radio label="right">右对齐</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="垂直对齐" class="mtx8 mrx8">
                    <el-radio-group
                      v-model="tdData.td.data.style.verticalAlign"
                    >
                      <el-radio label="baseline">上对齐</el-radio>
                      <el-radio label="middle">居中</el-radio>
                      <el-radio label="bottom">下对齐</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="字体大小" class="mtx8 mrx8">
                    <el-select v-model="tdData.td.data.style.fontSize">
                      <el-option
                        v-for="item in fonts"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="字体粗细" class="mtx8 mrx8">
                    <el-input
                      type="number"
                      v-snum
                      v-model="tdData.td.data.style.fontWeight"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="斜体" class="mtx8 mrx8">
                    <el-radio-group v-model="tdData.td.data.style.fontStyle">
                      <el-radio label="normal">普通</el-radio>
                      <el-radio label="italic">斜体</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="字体风格" class="mtx8 mrx8">
                    <el-select v-model="tdData.td.data.style.fontFamily">
                      <el-option
                        v-for="item in fontFamily"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
               <el-tab-pane label="汇总">
                <el-form
                  :model="sumForm"
                  label-width="80px "
                  v-if="isSumFormShow"
                >
                  <el-form-item label="行高" class="mtx8 mrx8">
                    <el-input
                      type="number"
                      v-snum
                      v-model="sumTrHight"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="水平对齐" class="mtx8 mrx8">
                    <el-radio-group v-model="sumForm.textAlign">
                      <el-radio label="left">左对齐</el-radio>
                      <el-radio label="center">居中</el-radio>
                      <el-radio label="right">右对齐</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="垂直对齐" class="mtx8 mrx8">
                    <el-radio-group
                      v-model="sumForm.verticalAlign"
                    >
                      <el-radio label="baseline">上对齐</el-radio>
                      <el-radio label="middle">居中</el-radio>
                      <el-radio label="bottom">下对齐</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="字体大小" class="mtx8 mrx8">
                    <el-select v-model="sumForm.fontSize">
                      <el-option
                        v-for="item in fonts"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="字体粗细" class="mtx8 mrx8">
                    <el-input
                      type="number"
                      v-snum
                      v-model="sumForm.fontWeight"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="斜体" class="mtx8 mrx8">
                    <el-radio-group v-model="sumForm.fontStyle">
                      <el-radio label="normal">普通</el-radio>
                      <el-radio label="italic">斜体</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="字体风格" class="mtx8 mrx8">
                    <el-select v-model="sumForm.fontFamily">
                      <el-option
                        v-for="item in fontFamily"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div
            class="attr_card"
            v-show="
              (divShow && divs.length !== 0) ||
                (divShow && bottomDivs.length !== 0)
            "
          >
            <div class="h3_title">内容设置</div>
            <div class="attrs m-scroll" style="height: 90%;">
              <el-form :model="divForm" label-width="80px ">
                <el-form-item label="文本" class="mtx8 mrx8">
                  <el-input v-model="divForm.text"></el-input>
                </el-form-item>
                <el-form-item label="宽度" class="mtx8 mrx8">
                  <div class="flex">
                    <el-input
                      type="number"
                      v-snum
                      style="flex: 1"
                      v-model="divForm.style.width"
                    ></el-input>
                    <el-select style="width: 60px;" v-model="divForm.widthUnit">
                      <el-option label="px" value="px"></el-option>
                      <el-option label="%" value="%"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item label="高度" class="mtx8 mrx8">
                  <div class="flex">
                    <el-input
                      type="number"
                      v-snum
                      style="flex: 1"
                      v-model="divForm.style.height"
                    ></el-input>
                    <el-select
                      style="width: 60px;"
                      v-model="divForm.heightUnit"
                    >
                      <el-option label="px" value="px"></el-option>
                      <el-option label="%" value="%"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item label="上距离" class="mtx8 mrx8">
                  <div class="flex">
                    <el-input
                      type="number"
                      style="flex: 1"
                      v-model="divForm.style.top"
                    ></el-input>
                    <el-select style="width: 60px;" v-model="divForm.topUnit">
                      <el-option label="px" value="px"></el-option>
                      <el-option label="%" value="%"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item label="左距离" class="mtx8 mrx8">
                  <div class="flex">
                    <el-input
                      type="number"
                      style="flex: 1"
                      v-model="divForm.style.left"
                    ></el-input>
                    <el-select style="width: 60px;" v-model="divForm.leftUnit">
                      <el-option label="px" value="px"></el-option>
                      <el-option label="%" value="%"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item label="水平对齐" class="mtx8 mrx8">
                  <el-radio-group v-model="divForm.style.justifyContent">
                    <el-radio label="flex-start">左对齐</el-radio>
                    <el-radio label="center">居中</el-radio>
                    <el-radio label="flex-end">右对齐</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="垂直对齐" class="mtx8 mrx8">
                  <el-radio-group v-model="divForm.style.alignItems">
                    <el-radio label="flex-start">上对齐</el-radio>
                    <el-radio label="center">居中</el-radio>
                    <el-radio label="flex-end">下对齐</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="字体大小" class="mtx8 mrx8">
                  <el-select v-model="divForm.style.fontSize">
                    <el-option
                      v-for="item in fonts"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="字体粗细" class="mtx8 mrx8">
                  <el-input
                    type="number"
                    v-snum
                    v-model="divForm.style.fontWeight"
                  ></el-input>
                </el-form-item>
                <el-form-item label="斜体" class="mtx8 mrx8">
                  <el-radio-group v-model="divForm.style.fontStyle">
                    <el-radio label="normal">普通</el-radio>
                    <el-radio label="italic">斜体</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="字体风格" class="mtx8 mrx8">
                  <el-select v-model="divForm.style.fontFamily">
                    <el-option
                      v-for="item in fontFamily"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="边框" class="mtx8 mrx8">
                  <el-checkbox v-model="divForm.style.isBorder" />
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- 属性设置 -->

          <!-- 表单属性设置 -->
           <div class="attr_card" v-show="formShow && formList.length !== 0">
            <div class="h3_title">表单内容设置</div>
            <el-tabs type="card" style="height: 80%">
              <el-tab-pane label="表单项目" class="attrs m-scroll">
                <div>
                  <el-form :data="formItemStyle" label-width="80px">
                    <el-form-item label="序号" class="mtx8 mrx8">
                      <el-input v-model="formItemStyle.sn" v-int @change="changeFormSn"></el-input>
                     </el-form-item>
                     <el-form-item label="标签名" class="mtx8 mrx8">
                      <el-input v-model="formItemStyle.label" ></el-input>
                     </el-form-item>
                    <el-form-item label="宽度" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="formItemStyle.style.width"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="formItemStyle.style.widthUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="高度" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="formItemStyle.style.height"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="formItemStyle.style.heightUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="左边距" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="formItemStyle.style.marginLeft"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="formItemStyle.style.marginLeftUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="右边距" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="formItemStyle.style.marginRight"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="formItemStyle.style.marginRightUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="上边距" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="formItemStyle.style.marginTop"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="formItemStyle.style.marginTopUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="下边距" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="formItemStyle.style.marginBottom"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="formItemStyle.style.marginBottom"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  </el-form>
                </div>
              </el-tab-pane>
              <el-tab-pane label="表单标签" class="attrs m-scroll">
                 <div>
                  <el-form :data="formLabelStyle" label-width="80px">
                    <el-form-item label="宽度" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="formLabelStyle.width"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="formLabelStyle.widthUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="高度" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="formLabelStyle.height"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="formLabelStyle.heightUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                    <el-form-item label="水平对齐" class="mtx8 mrx8">
                  <el-radio-group v-model="formLabelStyle.justifyContent">
                    <el-radio label="flex-start">左对齐</el-radio>
                    <el-radio label="center">居中</el-radio>
                    <el-radio label="flex-end">右对齐</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="垂直对齐" class="mtx8 mrx8">
                  <el-radio-group v-model="formLabelStyle.alignItems">
                    <el-radio label="flex-start">上对齐</el-radio>
                    <el-radio label="center">居中</el-radio>
                    <el-radio label="flex-end">下对齐</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="字体大小" class="mtx8 mrx8">
                  <el-select v-model="formLabelStyle.fontSize">
                    <el-option
                      v-for="item in fonts"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="字体粗细" class="mtx8 mrx8">
                  <el-input
                    type="number"
                    v-snum
                    v-model="formLabelStyle.fontWeight"
                  ></el-input>
                </el-form-item>
                <el-form-item label="斜体" class="mtx8 mrx8">
                  <el-radio-group v-model="formLabelStyle.fontStyle">
                    <el-radio label="normal">普通</el-radio>
                    <el-radio label="italic">斜体</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="字体风格" class="mtx8 mrx8">
                  <el-select v-model="formLabelStyle.fontFamily">
                    <el-option
                      v-for="item in fontFamily"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="边框" class="mtx8 mrx8">
                  <el-checkbox v-model="formLabelStyle.isBorder" />
                </el-form-item>
                  </el-form>
                </div>
              </el-tab-pane>
              <el-tab-pane label="表单值" class="attrs m-scroll">
                 <div>
                  <el-form :data="formValueStyle" label-width="80px">
                    <el-form-item label="宽度" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="formValueStyle.width"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="formValueStyle.widthUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="高度" class="mtx8 mrx8">
                    <div class="flex">
                      <el-input
                        type="number"
                        v-snum
                        style="flex: 1"
                        v-model="formValueStyle.height"
                      ></el-input>
                      <el-select
                        style="width: 60px;"
                        v-model="formValueStyle.heightUnit"
                      >
                        <el-option label="px" value="px"></el-option>
                        <el-option label="%" value="%"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                    <el-form-item label="水平对齐" class="mtx8 mrx8">
                  <el-radio-group v-model="formValueStyle.justifyContent">
                    <el-radio label="flex-start">左对齐</el-radio>
                    <el-radio label="center">居中</el-radio>
                    <el-radio label="flex-end">右对齐</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="垂直对齐" class="mtx8 mrx8">
                  <el-radio-group v-model="formValueStyle.alignItems">
                    <el-radio label="flex-start">上对齐</el-radio>
                    <el-radio label="center">居中</el-radio>
                    <el-radio label="flex-end">下对齐</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="字体大小" class="mtx8 mrx8">
                  <el-select v-model="formValueStyle.fontSize">
                    <el-option
                      v-for="item in fonts"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="字体粗细" class="mtx8 mrx8">
                  <el-input
                    type="number"
                    v-snum
                    v-model="formValueStyle.fontWeight"
                  ></el-input>
                </el-form-item>
                <el-form-item label="斜体" class="mtx8 mrx8">
                  <el-radio-group v-model="formValueStyle.fontStyle">
                    <el-radio label="normal">普通</el-radio>
                    <el-radio label="italic">斜体</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="字体风格" class="mtx8 mrx8">
                  <el-select v-model="formValueStyle.fontFamily">
                    <el-option
                      v-for="item in fontFamily"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="边框" class="mtx8 mrx8">
                  <el-checkbox v-model="formValueStyle.isBorder" />
                </el-form-item>
                  </el-form>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>

      <template slot="footer">
        <el-button type="primary" v-print="printPage" @click="print">打印</el-button>
        <!-- <el-button type="primary" @click="lodopPrint">打印</el-button> -->

      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import uploadFile from "@/components/common/files/uploadFile";


// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    uploadFile
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    defaultProps: {
      children: "children",
      label: "label",
    },
    formData: {
      type: Array,
      default: () => [],
    },
    imgUrl: {
      type: String,
      default: 'http://localhost:35972',
    }
  },

  data() {
    return {
      lodop: null,
      printPage: {
        id: 'page',
      },
      lodop: null,
      fonts: [12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 48, 64], // 字体大小
      fontFamily: ["宋体", "黑体", "楷体"], // 字体风格
      attrShow: true,
      columnsData: this.columns,
      form: {
        size: {
          value: "210*297",
          label: "A4",
        },
        direction: "portrait",
        border: true,
        tableCount: -1,
        formInputValue: '',
        isPageSize: true,
      },
      formInputShow: false,
      size: "A4",
      width: 210,
      height: 297,
      margin: 0,
      mmToPx: "",
      cssPagedMedia: null,
      paperType: [
        {
          key: "A3",
          label: "A3",
          value: "297*420",
        },
        {
          key: "A4",
          label: "A4",
          value: "210*297",
        },
        {
          key: "自定义",
          label: "自定义",
          value: "自定义",
        },
      ],
      topBorder: false,
      titleBorder: false,
      bottomBorder: false,
      tableForm: {
        width: 90,
        topHeight: 100,
        bottomHeight: 200,
        imgAreaHeight: 150,
        thead: {
          theadHeight: 36,
        },
        widthUnit: "%",
        position: {
          leftUnit: "%",
          topUnit: "%",
          left: 5,
          top: 0,
        },
        title: {
          name: "自定义标题",
          heightUnit: "px",
          widthUnit: "%",
          style: {
            height: 60,
            width: 100,
            justifyContent: 'center',
            alignItems: 'center',
            paddingLeft: 0,
            paddingLeftUnit: "px",
            paddingRight: 0,
            paddingRightUnit: "px",
            fontSize: 20,
            fontWeight: 700,
            fontStyle: "normal",
            fontFamily: "宋体",
          },
        },
      },
      thead: [], // 表头
      newThead: [], // 多级表头
      isTheadShow: false,
      currentTheadData: null,
      haveChildren: {
        keys: [],
        child: [],
      },
      attrForm: {
        columnName: "",
        isSum: false,
        width: "",
        sn: "",
        key: "",
        textAlign: "",
        verticalAlign: "",
        fontSize: 16,
        fontWeight: 600,
        fontStyle: "normal",
        fontFamily: "宋体",
      },
      tbodyData: [], // 存放完整数据
      tbodyDataLength: 0,
      tempTbodyData: [], // 用于动态循环
      trHeight: [],
      tdData: {}, // 动态的单元格样式数据
      divs: [],
      bottomDivs: [],
      divShow: true,
      divsProp: {
        label: "text",
        children: "children",
      },
      formDefaultProps: {
        label: "label",
        children: "children",
      },
      divId: 0,
      b_divId: 0,
      divForm: {
        // 自定义文本修改
        text: "",
        widthUnit: "",
        heightUnit: "",
        leftUnit: "",
        topUnit: "",
        style: {
          display: "",
          position: "",
          width: 0,
          height: 0,
          top: 0,
          left: 0,
          justifyContent: "",
          alignItems: "",
          fontSize: 0,
          fontWeight: 0,
          fontStyle: "",
          fontFamily: "",
          isBorder: true,
        },
      },
      waitDelDivIndex: -1,
      b_waitDelDivIndex: -1,
      pages: [0],
      tableCountMode: false,
      tableCountData: [],

      // 关于div移动的数据
      isDown: false,
      clientX: 0,
      clientY: 0,
      currentOffsetLeft: 0,
      currentOffsetTop: 0,

      //表单
      formContainer: {
        width: 90,
        widthUnit: '%',
        height: 90,
        heightUnit: 'px',
        isBorder: true,
        marginLeft: 5,
        marginLeftUnit: '%',
      },
      formDataList: [],
      formList: [],
      formShow: false,
      formItemStyle: {
        sn: '',
        key: '',
        label: '',
        style: {
          height: 0,
          width: 0,
          widthUnit: '',
          heightUnit: '',
          marginLeft: 0,
          marginRight: 0,
          marginTop: 0,
          marginBottom: 0,
          marginLeftUnit: 'px',
          marginRightUnit: 'px',
          marginTopUnit: 'px',
          marginBottomUnit: 'px',
        }
      },
      
      formLabelStyle: {
        height: 0,
        width: 0,
        widthUnit: '',
        heightUnit: '',
        justifyContent: '',
        alignItems: '',
        fontSize: 0,
        fontWeight: 0,
        fontStyle: "",
        fontFamily: "",
        isBorder: true,
      },
      formValueStyle: {
        height: 0,
        width: 0,
        widthUnit: '',
        heightUnit: '',
        justifyContent: '',
        alignItems: '',
        fontSize: 0,
        fontWeight: 0,
        fontStyle: "",
        fontFamily: "",
        isBorder: true,
      },
      // 汇总
      showSumTr: false,
      sumTrs: [],
      sumForm: {},
      sumTrHight: 30,
      isSumFormShow: false,
      countSumTrs: [], // 分页模式下的合计显示

      // 图片
      imgId: 0,
      imgList: [],
      imgForm: {},
      imgFormShow: false,
      currentImgId: -1,

    };
  },
  created() {
    this.cssPagedMedia = (function() {
      var style = document.createElement("style");
      document.head.appendChild(style);
      return function(rule) {
        style.innerHTML = rule;
      };
    })();

    let keys = [];
    let arr = [];
    this.columns.forEach(item => {
      if(item.children){
        keys.push(item.data.key);
        let key = item.data.key;
        let child = item.children.map(item1 => {
            return item1;
          })
        let o = {
          key,
          child,
        }

        arr.push(o);
      }
    })

    this.haveChildren.keys = keys;
    this.haveChildren.child = arr;



  },
  mounted() {
    let div = document.createElement("div");
    div.id = "mm";
    div.style.width = "1mm";
    document.querySelector("body").appendChild(div);
    // 原生方法获取浏览器对元素的计算值
    let mm1 = document.getElementById("mm").getBoundingClientRect();

    this.mmToPx = mm1.width;

    this.width = this.width * this.mmToPx;
    this.height = this.height * this.mmToPx;
    this.margin = this.margin * this.mmToPx;

    let that = this;

    this.cssPagedMedia.size = function(size) {
      console.log("size", size);
      that.cssPagedMedia(`@page{size: ${size}}`);
      that.cssPagedMedia(`  @media print {
            @page{
              size: ${size};
              margin: 0;
            }
            
        }`);
    };

    this.cssPagedMedia.size("A4 portrait");

  
    // console.log('this.cssPagedMedia', this.cssPagedMedia.size)
  },
  watch: {
    "attrForm.columnName": function(val) {
      this.currentTheadData.data.label = val;
    },
    "attrForm.width": function(val) {

      this.currentTheadData.data.style.width = Number(val);
    },
    "attrForm.textAlign": function(val) {

      this.currentTheadData.data.style.textAlign = val;
    },
    "attrForm.verticalAlign": function(val) {

      this.currentTheadData.data.style.verticalAlign = val;
    },
    "attrForm.fontSize": function(val) {

      this.currentTheadData.data.style.fontSize = Number(val);
    },
    "attrForm.fontWeight": function(val) {

      this.currentTheadData.data.style.fontWeight = Number(val);
    },
    "attrForm.fontStyle": function(val) {

      this.currentTheadData.data.style.fontStyle = val;
    },
    "attrForm.fontFamily": function(val) {

      this.currentTheadData.data.style.fontFamily = val;
    },
    "tdData.trHeight": function(val) {
      this.trHeight[this.tdData.trIndex] = val;
    },
    'formItemStyle.label':  function(val) {
      let data = this.formDataList.filter(item => {
        return item.key === this.formItemStyle.key
      })
      data[0].label = val;
    },
    data(tableData) {
      let length = tableData.length;
      this.tbodyDataLength = length;
      let trs = [];
      for (let i = 0; i < length; ++i) {
        this.trHeight.push(30);

        let tds = [];
        for (let key in tableData[i]) {
          let o = {
            key: "",
            data: {
              value: "",
              style: {
                textAlign: "center",
                verticalAlign: "middle",
                fontSize: 16,
                fontWeight: 400,
                fontStyle: "normal",
                fontFamily: "宋体",
              },
            },
          };
          o.key = key;
          o.data.key = key;
          o.data.value = tableData[i][key];
          tds.push(o);
        }

        trs.push(tds);
      }
      this.tbodyData = trs;

      console.log("this.tbodyData", this.tbodyData);
    },
    formData(list){
      let arr = [];
      list.forEach(item => {
         let o = {
          key: item.key,
          label: item.label,
          value: item.value,
          sn: 0,
          style: {
            height: 30,
            width: 240,
            widthUnit: 'px',
            heightUnit: 'px',
            marginLeft: 0,
            marginRight: 8,
            marginTop: 8,
            marginBottom: 0,
            marginLeftUnit: 'px',
            marginRightUnit: 'px',
            marginTopUnit: 'px',
            marginBottomUnit: 'px',
          },
          labelStyle: {
            height: 100,
            width: 30,
            widthUnit: '%',
            heightUnit: '%',
            justifyContent: 'flex-start',
            alignItems: 'center',
            fontSize: 16,
            fontWeight: 600,
            fontStyle: "normal",
            fontFamily: "宋体",
            isBorder: true,
          },
          valueStyle: {
            height: 100,
            width: 70,
            widthUnit: '%',
            heightUnit: '%',
            justifyContent: 'flex-start',
            alignItems: 'center',
            fontSize: 14,
            fontWeight: 400,
            fontStyle: "normal",
            fontFamily: "宋体",
            isBorder: true,
          }
        };

        arr.push(o)

      })
   

      this.formDataList = arr;
    },
    
  },
  methods: {
    print() {
      this.topBorder = false;
      this.titleBorder = false;
      this.bottomBorder = false;
      this.formContainer.isBorder = false;
      this.divs.forEach(item => {
        item.style.isBorder = false;
      })
       this.bottomDivs.forEach(item => {
        item.style.isBorder = false;
      })
       this.formList.forEach(item => {
        item.labelStyle.isBorder = false;
        item.valueStyle.isBorder = false;
      })
    },
    // lodopPrint(){

    //   this.topBorder = false;
    //   this.titleBorder = false;
    //   this.bottomBorder = false;
    //   this.formContainer.isBorder = false;
    //   this.divs.forEach(item => {
    //     item.style.isBorder = false;
    //   })
    //    this.bottomDivs.forEach(item => {
    //     item.style.isBorder = false;
    //   })
    //    this.formList.forEach(item => {
    //     item.labelStyle.isBorder = false;
    //     item.valueStyle.isBorder = false;
    //   })

    //   setTimeout(() => {
    //     this.lodop = getLodop();
    //     let init = this.lodop.PRINT_INIT("");
    //     let print = document.getElementById('page').innerHTML;

    //     let width = 0;
    //     let height = 0;

    //     if(!this.formInputShow){
    //       let size = this.form.size.value.split('*');
    //       width = Number(size[0]);
    //       height = Number(size[1]);
    //     }else{
    //       let size = this.form.formInputValue.split('*');
    //       width = Number(size[0]);
    //       height = Number(size[1]);
    //     }

    
        

    //     if(this.form.direction === 'portrait'){
    //       this.lodop.SET_PRINT_PAGESIZE(1, width * 10, height * 10, "");
    //       this.lodop.ADD_PRINT_HTM(0,0,this.width, this.height, print);
    //     }else{
    //       console.log('width', width, 'height', height);
    //       this.lodop.SET_PRINT_PAGESIZE(1, height * 10, width * 10, "");
    //       this.lodop.ADD_PRINT_HTM(0,0,this.width, this.height, print);
    //     }
    //     this.lodop.SET_PRINT_MODE("PRINT_PAGE_PERCENT",'Auto-Width');
        
    //     let status = this.lodop.GET_PRINTER_NAME(0);
    //     console.log('status', status)
    //     this.lodop.PREVIEW();
    //     // this.lodop.PRINT_DESIGN();
    //   }, 50)
      

    // },

     //数组中是否有children字段
    isHaveChildren(arr) {
      if (!arr) {
        return false;
      }
      for (let i = 0; i < arr.length; i++) {
        let item = arr[i];
        if (item.children && item.children.length) {
          return true;
        }
      }
      return false;
    },
    //获取该列合并的总数
    getColCount(data) {
      let sum = 0;
      if (!data) {
        return sum;
      }
      if (!data.children) {
        return sum;
      }
      let _this = this;
      let fn = function (arr) {
        if (!arr) {
          return sum;
        }
        arr.forEach((item) => {
          if (item.children) {
            fn(item.children);
          } else {
            sum++;
          }
        });
      };
      fn(data.children);
      return sum;
    },
    //构造多级表头数据
    getNewTheadData(p){
        let params = JSON.parse(JSON.stringify(p));
        if (!params) {
          return [];
        }
        let data = [],
          _this = this;
        var fn = function (arr) {
          if (!arr) {
            return [];
          }
          // 是否拥有多级表头
          let rowData = [];
          if (_this.isHaveChildren(arr)) {
            arr.forEach((item) => {
              if (item.children) {
                item.rowspan = 1;
                item.colspan = _this.getColCount(item);
                fn(item.children);
              } else {
                item.rowspan = arr.length;
                // item.rowspan = 2;
                item.colspan = 1;
              }
              rowData.push(item);
            });
          } else {
            arr.forEach((item) => {
              item.rowspan = 1;
              item.colspan = 1;
              rowData.push(item);
            });
          }
          data.unshift(rowData);
        };
        if (this.isHaveChildren(params)) {
          //重组
          this.rows = params.length;
          fn(params);
        } else {
          //不重组
          data.push(params);
        }
        return data;

    },


    getTheadData(key, thead) {
      
      console.log(key, thead)
      let o = null;
      let length = thead.length;
      
      for(let i = 0; i < length; ++i){
        if( thead[i].data.key === key){
          o = thead[i];
          return o
        }else{
          if(thead[i].children != undefined){
            o = this.getTheadData(key, thead[i].children);
            console.log('o', o)
          }
        }

      }
      
      console.log('end', o)
      return o

     
    },

    theadClick(item) {
      let index = -1;

      this.currentTheadData = item;
     console.log('theadClick', JSON.parse(JSON.stringify(this.currentTheadData)))
      if(item.data.parent != undefined){
        let data = this.thead.filter(v => {
          return v.data.key === item.data.parent[0]
        })[0]

        index = data.children.findIndex(v => {
          return v.data.key === item.data.key
        })
      }else{
         index = this.thead.findIndex(v => {
          return v.data.key === item.data.key
        })
      }
     

      this.isTheadShow = true;
     
      this.attrForm.columnName = item.data.label;
      this.attrForm.isSum = item.data.isSum;
      this.attrForm.width = item.data.style.width;
      this.attrForm.textAlign = item.data.style.textAlign;
      this.attrForm.verticalAlign = item.data.style.verticalAlign;

      this.attrForm.fontSize = item.data.style.fontSize;
      this.attrForm.fontWeight = item.data.style.fontWeight;
      this.attrForm.fontStyle = item.data.style.fontStyle;
      this.attrForm.fontFamily = item.data.style.fontFamily;

      this.attrForm.sn = index;
      this.attrForm.key = item.data.key;

    },
    isBodyKey(key){
      let index = this.tempTbodyData[0].findIndex(item => {
        return item.key === key
      })

      let bool = index === -1 ? false : true;

      return bool

    },
    delCellIndex(data){

      let index = this.tempTbodyData[0].findIndex(item => {
        return item.key === data.data.key
      })

      return index;
    },
    getChildCellIndex(data){
        let moveIndex = 0;
        let parentIndex = this.newThead[0].findIndex(item => {
            return item.data.key === data.data.parent[0]
          })

          let childIndex = this.newThead[1].findIndex(item => {
            return item.data.key === data.data.parent[1]
          })

           moveIndex = parentIndex + childIndex;

        return moveIndex;

        // 表体子级要移动到的位置
    
    },
    getHeadToBodyIndex(data){ // 表头对应的表体数据的位置
      let arr = [];
      let childNum = 0;
      let length = this.newThead[0].length;
      for(let i = 0; i < length; ++i){

        if(this.newThead[0][i].data.key === data.data.key){
          break;
        }else{
          arr.push(this.newThead[0][i].data.key)
        }
        
      }
      

      let parentIndex = [];
      if(arr.length !== 0 && this.newThead[1]){
        this.newThead[1].forEach(item => {
          let index = arr.indexOf(item.data.parent[0]);
          if(index !== -1){
            parentIndex.push(index)
            ++childNum;
          }
        })
        parentIndex = Array.from(new Set(parentIndex));
        childNum = childNum - parentIndex.length;
      }

     

      return arr.length + childNum;


    },
    getTbodyTdValue(data){

      let valueData = [];
      this.tbodyData.forEach(item => {
        let arr = item.filter(item => {
          return data.data.key === item.key
        })[0]
        
        valueData.push(arr)
      })
      

      return valueData;
    },
    tbodySpliceCell(data){
        let tdData = this.getTbodyTdValue(data)
        if(data.data.parent){
          console.log('data', data)
          let index = this.getChildCellIndex(data);
          console.log('cell-index', index)

           if (this.tempTbodyData.length === 0) {
              let trs = [];
              for (let i = 0; i < this.tbodyDataLength; ++i) {
                let tds = [];
                tds.push(tdData[i]);
                trs.push(tds);
              }
              this.tempTbodyData = trs;
            } else {
              for (let i = 0; i < this.tempTbodyData.length; ++i) {
                this.tempTbodyData[i].splice(index, 0, tdData[i]);
              }
            }

            
        }else{
          let index = this.getHeadToBodyIndex(data);

            if (this.tempTbodyData.length === 0) {
              let trs = [];
              for (let i = 0; i < this.tbodyDataLength; ++i) {
                let tds = [];
                tds.push(tdData[i]);
                trs.push(tds);
              }
              this.tempTbodyData = trs;
            } else {
              for (let i = 0; i < this.tempTbodyData.length; ++i) {
                this.tempTbodyData[i].splice(index, 0, tdData[i]);
              }
            }
        }
    },
    createTbody(data){
        let tdData = this.getTbodyTdValue(data)

        if(data.data.parent){
          let index = this.getChildCellIndex(data);

           if (this.tempTbodyData.length === 0) {
              let trs = [];
              for (let i = 0; i < this.tbodyDataLength; ++i) {
                let tds = [];
                tds.push(tdData[i]);
                trs.push(tds);
              }
              this.tempTbodyData = trs;
            } else {
              for (let i = 0; i < this.tempTbodyData.length; ++i) {
                this.tempTbodyData[i].splice(index, 0, tdData[i]);
              }
            }
        }else{
           if (this.tempTbodyData.length === 0) {
              let trs = [];
              for (let i = 0; i < this.tbodyDataLength; ++i) {
                let tds = [];
                tds.push(tdData[i]);
                trs.push(tds);
              }
              this.tempTbodyData = trs;
            } else {
              for (let i = 0; i < this.tempTbodyData.length; ++i) {
                this.tempTbodyData[i].push(tdData[i]);
              }
            }
        }
       
    },
    handleCheckChange(data) {

      let addMode = true;
      let childFill = true; // 子级全选了，或全没选
      if(data.data.parent != undefined ){ // 有父级

        let parentChain = data.data.parent;
        
        let currentData = this.thead.filter(item => {
          return item.data.key === parentChain[0];
        })[0];

        // 父级没有被添加，添加拿到父级
        if(currentData == undefined){
          let tempData = JSON.parse(JSON.stringify(this.columns.filter(item => {
            return item.data.key === parentChain[0];
          })[0]))

          let children = JSON.parse(JSON.stringify(tempData.children));
          
          tempData.children = [];
          children = children.filter(item => {
            return item.data.key === parentChain[1];
          })[0];

          
          tempData.children.push(children)

          this.thead.push(tempData);
          
        }else{
          // 点击的对象有没有被添加进去

          let index = currentData.children.findIndex(item => {
            return item.data.key === parentChain[1];
          })
          if(index !== -1){
            currentData.children.splice(index, 1);

            if(currentData.children.length === 0){

              let index = this.thead.findIndex(item => {
                return item.data.key === parentChain[0];
              });

              this.thead.splice(index, 1)
            }

            addMode = false;

            // 删除
            let tbodyDataCellIndex = this.delCellIndex(data);
            
             for (let i = 0; i < this.tbodyDataLength; ++i) {
              this.tempTbodyData[i].splice(tbodyDataCellIndex, 1);
            }
            
            
            

          }else{
            let tempData = JSON.parse(JSON.stringify(this.columns.filter(item => {
              return item.data.key === parentChain[0];
            })[0]))

            let children = tempData.children.filter(item => {
              return item.data.key === parentChain[1];
            })[0];

             currentData.children.push(children)


          }
         
        }



        

      }else{ // 没有父级

    

       let _data = data.data;
       let index = this.thead.findIndex((item) => {
          return item.data.key === _data.key;
        });

        if(index === -1){
          this.thead.push(JSON.parse(JSON.stringify(data)));
        }else{
          if(data.children != undefined && this.thead[index].children.length < data.childrenSize){
          

            childFill = false;

            this.thead.splice(index, 1);
            this.thead.splice(index, 0, data);

            

          }else{

            let haveChildrenIndex = this.haveChildren.keys.indexOf(data.data.key);

             if(haveChildrenIndex === -1){
                let tbodyIndex = this.delCellIndex(data);
                for (let i = 0; i < this.tbodyDataLength; ++i) {
                  this.tempTbodyData[i].splice(tbodyIndex, 1);
                }
              }else if(haveChildrenIndex !== -1){
                let child = this.haveChildren.child[haveChildrenIndex].child;
                child.forEach(item => {
                  let tbodyIndex = this.delCellIndex(item);
                 
                   for (let i = 0; i < this.tbodyDataLength; ++i) {
                    this.tempTbodyData[i].splice(tbodyIndex, 1);
                  }
                })
              }
            
            
            this.thead.splice(index, 1);

            addMode = false
          }
          
        
        }
      }

      this.newThead = this.getNewTheadData(this.thead);
      let haveChildrenIndex = this.haveChildren.keys.indexOf(data.data.key);


      if(addMode && haveChildrenIndex === -1){
        this.createTbody(data)
      }else if(addMode && haveChildrenIndex !== -1 && childFill){
        let child = this.haveChildren.child[haveChildrenIndex].child;
        child.forEach(item => {
          this.createTbody(item)
        })
      }else if(addMode && haveChildrenIndex !== -1 && !childFill){

            let child = this.haveChildren.child[haveChildrenIndex].child;
            let waitAdd = [];
            child.forEach(item => {
              
              let bool = this.isBodyKey(item.data.key);
              if(!bool){
                waitAdd.push(item)
              }
              
            })

            waitAdd.forEach(item => {
              this.createTbody(item)
            })

      }

      if(this.showSumTr){
        this.showSumFunc(false);
        this.showSumFunc(true);
      }

     
    },
    changeSize({ value, label }) {
      
      if(value !== '自定义'){
        this.formInputShow = false;
        this.form.formInputValue = "";
        let width = value.split("*")[0];
        this.width = Number(width) * this.mmToPx;

        let height = value.split("*")[1];
        this.height = Number(height) * this.mmToPx;

        this.size = label;

        if (this.form.direction === "landscape") {
          // 横向
          this.changeDirection("landscape");
        }

        this.cssPagedMedia.size(`${this.size} ${this.form.direction}`);
      }else{
        this.formInputShow = true;
      }
      
    },
    changeInputValue(){

      let value = this.form.formInputValue;
      console.log('this.form.formInputValue', this.form.formInputValue)
      let width = value.split("*")[0];
      this.width = Number(width) * this.mmToPx;

      let height = value.split("*")[1];
      this.height = Number(height) * this.mmToPx;

      if (this.form.direction === "landscape") {
        // 横向
        this.changeDirection("landscape");
      }
      this.cssPagedMedia.size(`${this.size} ${this.form.direction}`);

    },
    changeDirection(value) {
      let height = this.width;
      let width = this.height;
      this.width = width;
      this.height = height;

      this.cssPagedMedia.size(`${this.size} ${value}`);
    },
    changeSn(val) {
      let theadData = this.currentTheadData;
      let waitAddChild = [];
      if(theadData.data.parent != undefined){
        let index = -1;

        let data = this.thead.filter(v => {
          return v.data.key === theadData.data.parent[0]
        })[0]
        
        if (val >= data.children.length) {
          this.$message({
            type: "warning",
            message: "不能超过要打印的表格的列表项长度",
          });
          return;
        }

        index = data.children.findIndex(item => {
          return item.data.key === theadData.data.key
        })


       // 获取表体原位置数据，以及目的地的表体位置坐标
        let waitDataIndex = this.delCellIndex(theadData); // 原表体位置

        // 删除原位置数据
        for (let i = 0; i < this.tbodyDataLength; ++i) {
          this.tempTbodyData[i].splice(waitDataIndex, 1);
        }

        
        // 移动表头
        data.children.splice(index, 1);
        let copyData = JSON.parse(JSON.stringify(theadData));
        delete copyData.colspan
        delete copyData.rowspan

        data.children.splice(val, 0, copyData);


      }else{
        if (val >= this.thead.length) {
          this.$message({
            type: "warning",
            message: "不能超过要打印的表格的列表项长度",
          });
          return;
        }

        let index = -1;
        index = this.thead.findIndex(item => {
          return item.data.key === theadData.data.key
        })
        
         let haveChildrenIndex = this.haveChildren.keys.indexOf(theadData.data.key);

          if(haveChildrenIndex === -1){

            // 获取表体原位置数据，以及目的地的表体位置坐标
            let waitDataIndex = this.delCellIndex(theadData); // 原表体位置

            // 删除原位置数据
            for (let i = 0; i < this.tbodyDataLength; ++i) {
              this.tempTbodyData[i].splice(waitDataIndex, 1);
            }

          }else if(haveChildrenIndex !== -1){
            let child = this.haveChildren.child[haveChildrenIndex].child;

            child.forEach(item => {
              let tbodyIndex = this.delCellIndex(item);
                if(tbodyIndex !== -1){
                  waitAddChild.push(item.data.key);
                  for (let i = 0; i < this.tbodyDataLength; ++i) {
                    this.tempTbodyData[i].splice(tbodyIndex, 1);
                  }
                  this.sumTrs.splice(tbodyIndex, 1)
                }
               
            })

          }
        
        // 移动头部
        this.thead.splice(index, 1);
        let copyData = JSON.parse(JSON.stringify(theadData));
        delete copyData.colspan
        delete copyData.rowspan

        this.thead.splice(val, 0, copyData);

      }

      this.newThead = this.getNewTheadData(this.thead);

       let haveChildrenIndex = this.haveChildren.keys.indexOf(theadData.data.key);

        if(haveChildrenIndex === -1){

          this.tbodySpliceCell(theadData)

        }else if(haveChildrenIndex !== -1){
          
          let arr = [];
          this.newThead[1].forEach(item => {
            if(item.data.parent[0] === theadData.data.key){
              arr.push(item)
            }
          })

          arr.forEach(item => {

            if(waitAddChild.indexOf(item.data.key) !== -1){
              this.tbodySpliceCell(item)
            }
          })
        }

        if(this.showSumTr){
          this.showSumFunc(false);
          this.showSumFunc(true);
        }

    },
    trClick(index, currentTr, event) {
      let tdIndex = event.target.getAttribute("data-index");
      let o = {
        trIndex: index,
        tdIndex: tdIndex,
        trHeight: this.trHeight[index],
        td: currentTr[tdIndex],
      };
      this.tdData = o;
    },
   
    tabClick({ index }) {
      if (index === "2") {
        this.attrShow = true;
      } else {
        this.attrShow = false;
      }
      if (index === "6") {
        this.divShow = true;
      } else {
        this.divShow = false;
      }

      if(index === '0'){
        this.formShow = true;
      }else{
        this.formShow = false;
      }
    },
    createDIV() {
      let o = {
        key: "div" + this.divId,
        text: "自定义文本",
        widthUnit: "px",
        heightUnit: "px",
        leftUnit: "%",
        topUnit: "%",
        style: {
          display: "flex",
          position: "absolute",
          width: 100,
          height: 30,
          top: 0,
          left: 0,
          justifyContent: "center",
          alignItems: "center",
          fontSize: 16,
          fontWeight: 400,
          fontStyle: "normal",
          fontFamily: "宋体",
          isBorder: true,
        },
      };
      this.divs.push(o);
      this.divId++;
    },
    b_createDIV() {
      let o = {
        key: "b_div" + this.b_divId,
        text: "自定义文本",
        widthUnit: "px",
        heightUnit: "px",
        leftUnit: "px",
        topUnit: "px",
        style: {
          display: "flex",
          position: "relative",
          width: 100,
          height: 30,
          top: 0,
          left: 0,
          justifyContent: "center",
          alignItems: "center",
          fontSize: 16,
          fontWeight: 400,
          fontStyle: "normal",
          fontFamily: "宋体",
          isBorder: true,
        },
      };
      this.bottomDivs.push(o);
      this.b_divId++;
    },
    //树形控件选择div
    handleNodeClickDiv(data) {
      this.divForm = data;

      let key = data.key;
      this.waitDelDivIndex = this.divs.findIndex((item) => {
        return item.key === key;
      });
    },
    b_handleNodeClickDiv(data) {
      this.divForm = data;

      let key = data.key;
      this.b_waitDelDivIndex = this.bottomDivs.findIndex((item) => {
        return item.key === key;
      });
      console.log("b_waitDelDivIndex", this.b_waitDelDivIndex);
    },
    delDiv() {
      this.divs.splice(this.waitDelDivIndex, 1);
    },
    b_delDiv() {
      this.bottomDivs.splice(this.b_waitDelDivIndex, 1);
    },
    tableCountFunc() {
      let count = Number(this.form.tableCount);

      if (count <= 0) {
        this.tableCountMode = false;
        this.pages = [0];
        return;
      }

      let trs = this.tempTbodyData.length;
      let remainder = trs % count === 0 ? 0 : 1;

      let res = parseInt(trs / count);
      let sum = res + remainder;

      this.pages = [];
      for (let i = 0; i < sum; ++i) {
        this.pages.push(i);
      }

      let index = 1;

      let arr = [];
      let arr1 = [];
      for (let i = 0; i < trs; ++i) {
        if (index > count) {
          index = 1;
          arr1 = [];
        }

        arr1.push(this.tempTbodyData[i]);
        if (index === count && i !== trs - 1) {
          arr.push(arr1);
        }

        if (i === trs - 1) {
          arr.push(arr1);
        }

        ++index;
      }

      this.tableCountMode = true;
      this.tableCountData = arr;


      // 合计行
      this.pageSum();

    },
    // 移动div
    divMouseDown(e, item){
      
      let {clientX, clientY} = e;
      this.clientX = clientX - this.$refs[item.key][0].offsetLeft;
      this.clientY =  clientY - this.$refs[item.key][0].offsetTop;
      // item.style.left = this.$refs[item.key][0].offsetLeft;
      // item.style.top =  this.$refs[item.key][0].offsetTop;
      console.log('clientX', clientX, 'clientY', clientY)
      console.log('offsetLeft', this.$refs[item.key][0].offsetLeft, 'offsetTopY', this.$refs[item.key][0].offsetTop)


      this.isDown = true;

    },
    divMouseMove(e, item){

      if(this.isDown){
        let left = e.clientX - this.clientX;
        let top = e.clientY - this.clientY
        item.style.left = left;
        item.style.top =  top;
      }
    },
    divMouseUp(){
      this.isDown = false;
    },

    //表单
    formHandleNodeClick(data){

      let index = this.formList.findIndex((item) => {
        return item.key === data.key;
      });
      if(index !== -1){
        this.formShow = true;
        this.formItemStyle.sn = index;
        this.formItemStyle.key = data.key;
        this.formItemStyle.label = data.label;
        this.formItemStyle.style = data.style;
        this.formLabelStyle = data.labelStyle;
        this.formValueStyle = data.valueStyle;


      }
    
    },
    formFandleCheckChange(data){
      // 查找是否有该值，没有就添加，有就删除
      let index = this.formList.findIndex((item) => {
        return item.key === data.key;
      });
      if(index === -1){
          this.formShow = true;
          this.formList.push(data);
          this.formItemStyle.sn = this.formList.length - 1;
          this.formItemStyle.key = data.key;
          this.formItemStyle.label = data.label;

          this.formItemStyle.style = data.style;

          this.formLabelStyle = data.labelStyle;
          this.formValueStyle = data.valueStyle;

      }else{
        this.formList.splice(index, 1);
        this.formShow = false;
      }
    },
    changeFormSn(val){
       if (Number(val) >= this.formList.length) {
        this.$message({
          type: "warning",
          message: "不能超过要打印的表单项长度",
        });
        return;
      }

      let key = this.formItemStyle.key;
      let index = this.formList.findIndex((item) => {
        return item.key === key;
      });
      let o = this.formList[index];
      this.formList.splice(index, 1);

      this.formList.splice(Number(val), 0, o);

    },
    // 合计
    showSumFunc(val){

      this.showSumTr = val;

      if(!this.showSumTr){
        return
      }

      if(this.tableCountMode){
        this.pageSum();
      }

      let arr = [];
      let keys = [];
      let sumObj = {};
      let first = true;
      if(val){

        // tempTbodyData
        // 先获取哪些列需要合计
        this.newThead[0].forEach((item, index) => {
          if(index === 0 && !item.children ){
            let o = {
              key: item.data.key,
              value: '合计',
              style: {
                textAlign: "left",
                verticalAlign: "middle",
                fontSize: 16,
                fontWeight: 600,
                fontStyle: "normal",
                fontFamily: "宋体",
              }
            }
            arr.push(o);
            first = false;
          }else{
            if(item.data.isSum){
              sumObj[item.data.key] = 0;
              keys.push(item.data.key);
            }
          }
        })
        this.newThead[1] && this.newThead[1].forEach((item, index) => {
          if(index === 0 && first ){
            let o = {
              key: item.data.key,
              value: '合计',
              style: {
                textAlign: "left",
                verticalAlign: "middle",
                fontSize: 16,
                fontWeight: 600,
                fontStyle: "normal",
                fontFamily: "宋体",
              }
            }
            arr.push(o);
            first = false;
          }else{
            if(item.data.isSum){
              sumObj[item.data.key] = 0;
              keys.push(item.data.key);
            }
          }
        })

        console.log('sumObj', sumObj)
        
        let length = this.tempTbodyData.length;
        this.tempTbodyData.forEach((item, index) => {
          item.forEach((v, i) => {
            if(i !== 0){
              if(index === 0){
                let o = {
                  key: v.key,
                  value: '',
                  style: {
                    textAlign: "center",
                    verticalAlign: "middle",
                    fontSize: 16,
                    fontWeight: 600,
                    fontStyle: "normal",
                    fontFamily: "宋体",
                  }
                }
                arr.push(o)
              }
              if(keys.indexOf(v.key) !== -1){
                sumObj[v.key] += Number(v.data.value)
              }
            }
          })

          if(index === length -1){
            arr.forEach(item => {
              if(keys.indexOf(item.key) !== -1){
                item.value = sumObj[item.key];
              }
            })
          }
        })
        this.sumTrs = arr;

      }
    },
    changeIsSum(val){

      let theadData = this.currentTheadData;
      
      let index = this.delCellIndex(theadData);

      let data = this.sumTrs[index];
      if(data.value === '合计'){
        this.$message({
          type: 'warning',
          message: '该字段的值不能参与合计'
        })
        return
      }
      if(val){
        let length = this.tempTbodyData.length;

        
        let sum = 0;
        for(let i = 0; i < length; ++i){
          let value = Number(this.tempTbodyData[i][index].data.value)
          if(isNaN(value)){
            this.$message({
              type: 'warning',
              message: '该字段的值不能参与合计'
            })
            this.attrForm.isSum = false;
            return 
          }
          sum += value;
        }
        theadData.data.isSum = val;
        data.value = sum;

      }else{
        theadData.data.isSum = val;
        data.value = "";
      }

    },
    sumTdClick(item){

      if(item.value === ''){
        this.isSumFormShow = false;
        return;
      }
      this.isSumFormShow = true;
      this.sumForm = item.style;
   
    },
    pageSum(){
       // 确定需要合计的单元格
      let sumObj = {};
      let keys = [];
      let first = true;
      this.newThead[0].forEach((item, index) => {
          if(index === 0 && !item.children ){
            let o = {
              key: item.data.key,
              value: '合计',
              style: {
                textAlign: "left",
                verticalAlign: "middle",
                fontSize: 16,
                fontWeight: 600,
                fontStyle: "normal",
                fontFamily: "宋体",
              }
            }
            first = false;
          }else{
            if(item.data.isSum){
              sumObj[item.data.key] = 0;
              keys.push(item.data.key);
            }
          }
        })
        this.newThead[1] && this.newThead[1].forEach((item, index) => {
          if(index === 0 && first ){
            let o = {
              key: item.data.key,
              value: '合计',
              style: {
                textAlign: "left",
                verticalAlign: "middle",
                fontSize: 16,
                fontWeight: 600,
                fontStyle: "normal",
                fontFamily: "宋体",
              }
            }
            first = false;
          }else{
            if(item.data.isSum){
              sumObj[item.data.key] = 0;
              keys.push(item.data.key);
            }
          }
        })

      let length = this.tableCountData.length;
      let sum_arr = [];
      for(let i = 0; i < length; ++i){  // 页
        let sum_line_arr = [];
        for(let item in sumObj){
          sumObj[item] = 0;
        }
        let subLength = this.tableCountData[i].length;
        for(let j = 0; j < subLength; ++j){ // 行
          
          let tds = this.tableCountData[i][j];

          for(let k = 0; k < tds.length; ++k){
            let key = tds[k].key;
            if(j === 0 && k === 0){
              let o = {
                key: key,
                value: '合计',
                style: {
                  textAlign: "left",
                  verticalAlign: "middle",
                  fontSize: 16,
                  fontWeight: 600,
                  fontStyle: "normal",
                  fontFamily: "宋体",
                }
              }
              sum_line_arr.push(o);
            }else{

              if(j === 0){
                let o = {
                  key: key,
                  value: '',
                  style: {
                    textAlign: "center",
                    verticalAlign: "middle",
                    fontSize: 16,
                    fontWeight: 600,
                    fontStyle: "normal",
                    fontFamily: "宋体",
                  }
                }
                sum_line_arr.push(o);
              }
              if(keys.indexOf(key) !== -1){
                sumObj[key] += Number(tds[k].data.value)
              }
            }
          }
          
       

          if(j === subLength - 1){
            sum_line_arr.forEach(item => {
              if(keys.indexOf(item.key) !== -1){
                item.value = sumObj[item.key];
              }
            })
          }
        }

        sum_arr.push(sum_line_arr);
       
      }

      console.log('sum_arr', sum_arr)
      this.countSumTrs = sum_arr;
    },

    // 图片
    addImg(file){
      let src = this.imgUrl + file
      let o = {
        key: 'img' + this.imgId,
        src: src,
        style: {
          width: 50,
          widthUnit: 'px',
          height: 50,
          heightUnit: 'px',
          left: 0,
          leftUnit: 'px',
          top: 0,
          topUnit: 'px',
          borderRadius: false,
        }
      }

      this.imgList.push(o);

      ++this.imgId;

    },
    imgClick(item){
      
      this.imgForm = item;
      this.imgFormShow = true;
      this.currentImgId = item.key;

    },
    delImg(){
      if(this.currentImgId !== -1){
        let index = this.imgList.findIndex(item => {
          return item.key === this.currentImgId;
        })
        this.imgList.splice(index, 1);

        if(this.imgList.length === 0){
          this.imgFormShow = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body > div {
  height: 100%;
  margin: 0;
}

.flex {
  display: flex;
}
.flex_wrap{
  flex-wrap: wrap;
  
}
.justify {
  justify-content: flex-end;
}
.print {
  display: flex;
  height: 100%;
  overflow: hidden;

  .print_tool {
    width: 360px;
    margin-left: 8px;
  }

  .print_view {
    flex: 1;
    position: relative;
    height: 100%;
    max-width: 1500px;

    .print_view_div {
      height: 100%;
      overflow: auto;

      .page_content {
        position: relative;

        .div_texts {
          position: relative;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
        }
      }

      .page_border {
        border: 1px solid #e4e7ed;
      }
    }
  }

  // .page_content{
  //   page-break-before:avoid;//前面不加空页
  // 	page-break-after:avoid;//后面不加空页
  // }
}

.tree {
  font-size: 14px;
}
.columns_name {
  height: 40%;
  overflow: auto;
  border: 1px solid #e4e7ed;
  border-top: none;
}
/deep/ .el-tree .el-tree-node .el-tree-node__content {
  height: 30px;
}
/deep/ .el-tabs__header {
  margin: 0 0 0px;
}

.mtx8 {
  margin-top: 8px;
}
.mrx8 {
  margin-right: 8px;
}
.page_form{
  position: relative;
}
.table {
  position: relative;
  border-collapse: collapse;
}

.h3_title {
  height: 30px;
  text-align: center;
  background: #333;
  color: #fff;
  line-height: 30px;
}

.attr_card {
  height: 50%;
  overflow: hidden;

  /deep/ .el-tabs__content {
    height: 100%;
  }

  .attrs {
    overflow: auto;
    border: 1px solid #e4e7ed;
    border-top: none;
    height: 100%;
  }
}

.img_area{
  height: 150px;
  position: relative;

  .img_box{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    .img{
      width: 100%;
    }
  }
  
}

/deep/ .el-divider {
  position: absolute; bottom: 10px;
  background-color: transparent;
}

/deep/ .el-form-item__label{
  min-width: 80px;
}
</style>
